import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Suspense as _Suspense, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-996e6706")

_pushScopeId("data-v-996e6706")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Loading... ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_AppAdmin = _resolveComponent("AppAdmin")
  const _component_AppUser = _resolveComponent("AppUser")
  const _component_v_wait = _resolveComponent("v-wait")

  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withId(() => [
      _createVNode("div", null, [
        (_ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_AppAdmin, { key: 0 }, {
              default: _withId(() => [
                _createVNode(_component_router_view, { class: "contents" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isNotAdmin)
          ? (_openBlock(), _createBlock(_component_AppUser, { key: 1 }, {
              default: _withId(() => [
                _createVNode(_component_router_view, { class: "contents" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_wait)
      ])
    ]),
    fallback: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})